import { render, staticRenderFns } from "./CampaignsPopup.vue?vue&type=template&id=5419a463&scoped=true"
import script from "./CampaignsPopup.vue?vue&type=script&lang=ts"
export * from "./CampaignsPopup.vue?vue&type=script&lang=ts"
import style0 from "./CampaignsPopup.vue?vue&type=style&index=0&id=5419a463&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5419a463",
  null
  
)

export default component.exports